<template>
    <div class="flex mt-1 rounded-md shadow-sm">
        <span
            class="inline-flex items-center px-3 text-sm text-gray-500 border border-r-0 border-gray-300 rounded-l-md bg-gray-50"
        >
            {{ config(common.currency, $page.props.user) }}
        </span>
        <input
            ref="input"
            :v-model="value"
            class="w-full border-gray-300 rounded-md rounded-tl-none rounded-bl-none"
            type="number"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
        >
    </div>
</template>

<script>
import common from '../common';

export default {
    props: ['placeholder', 'value'],

    data() {
        return {
            common,
        };
    },

    methods: {
        focus() {
            this.$refs.input.focus();
        },
    },
};
</script>
